import { Button, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigateToTop } from "../../libs/useNavigateToTop";
import AppBarMenu from "./Menu";
import AppBarRoot from "./Root";
import jsPDF from "jspdf";
import { ArrowBack, Save } from "@mui/icons-material";

function AppBarCreateGuide({ title = "Create Guide", canSave, onSave }) {
  const navigate = useNavigateToTop();

  

  const handleExportGuide = () => {
    const doc = new jsPDF(
      // landscape
      "l",
      "pt",
      "a3"
    );
    doc.html(document.querySelector('body'), {
      callback: function (doc) {
        // Add species name to the top of the document
        doc.text("Species Name: YourSpeciesName", 10, 10);
        
        doc.save('MLB World Series Winners.pdf');
      },
      // make it fit
      x: 10,
      y: 10,
      width: 1000,
      //make fit
      windowWidth: 1000,

      // auto page
      autoPaging: true
    });
  }

  return (
    <AppBarRoot
      startAction={
        <Stack direction={"row"} spacing={2}>
          {/* <AppBarMenu /> */}
          {/* Back button */}
          <IconButton onClick={() => navigate(-1)}
          color="secondary">
            <ArrowBack />
          </IconButton>
          <Typography
            onClick={() => navigate("/")}
            variant="h5"
            style={{ alignSelf: "center", color: "white" }}
          >
            {title}
          </Typography>
        </Stack>
      }
      endAction={
        <Stack direction={"row"} spacing={1}>
        {/* Button to save */}
        <Button variant="contained" color="secondary"
          onClick={onSave}
          disabled={!canSave}
          startIcon={<Save />}
          >
            Save
          </Button>
        </Stack>
      }
    />
  );
}

export default AppBarCreateGuide;
